<div class="review-container">

  <!-- Header -->
  <div class="breadcrumb">
    <span class="icon">📊</span>
    <span>Dashboard & Select for Review</span>
  </div>

  <div class="review-card">

    <div class="card-header">
      <h3>Selected Proposals for Review</h3>
    </div>

    <div class="proposal-box">

      <div class="proposal-header">
        <span class="proposal-title">New proposal (Idex 4 Fauji)</span>

        <button class="btn-outline" (click)="openUploadDocument()">
          + ADD ACTION POINT
        </button>
      </div>

      <div class="empty-state">
        <p>No action points yet.</p>

        <button class="btn-outline small" (click)="openUploadDocument()">
          ADD ONE
        </button>
      </div>

    </div>

  </div>

  <!-- Footer Buttons -->
  <div class="footer-buttons">

    <button class="btn-back">
      ← BACK TO DASHBOARD
    </button>

    <button class="btn-submit">
      ✈ SUBMIT FOR REVIEW
    </button>

  </div>

</div>


<!-- Upload Document Section -->
<div *ngIf="showUploadDocument">
  <hr class="my-3" />

  <app-upload-document
    [isEditable]="stepDetails?.can_edit">
  </app-upload-document>
</div>